import AuthSlice from './slices/AuthSlice'
import AdminSlice from './slices/AdminSlice'
import UserSlice from './slices/UserSlice'
import RequestSlice from './slices/RequestSlice'
import FleetSlice from './slices/FleetSlice'
import UsedEquipmentSlice from './slices/UsedEquipmentSlice'
import AlertSlice from './slices/AlertSlice'
import LoadingSlice from './slices/LoadingSlice'

export default {
    AuthSlice: AuthSlice,
    AdminSlice: AdminSlice,
    UserSlice: UserSlice,
    RequestSlice: RequestSlice,
    FleetSlice: FleetSlice,
    UsedEquipmentSlice: UsedEquipmentSlice,
    AlertSlice: AlertSlice,
    LoadingSlice: LoadingSlice,
}
